import { Injectable } from '@angular/core';
import {
  CanActivate, Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  CanActivateChild,
  NavigationExtras,
  CanLoad, Route
} from '@angular/router';
import { SignInService } from './sign-in/sign-in.service';
import { AuthService } from './service/auth.service';
import { NavigationService } from './navigation/navigation.service';

@Injectable({
  providedIn: 'root',
})
export class RouterGuard implements CanActivate, CanActivateChild, CanLoad {
  constructor(
        private authService: AuthService,
        private navigationService: NavigationService,
        private router: Router,
        private signinService: SignInService    
    ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const url: string = state.url;
    return this.checkLogin(url);
  }

  canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.canActivate(route, state);
  }

  canLoad(route: Route): boolean {
    const url = `/${route.path}`;
    return this.checkRoutePermission(url);
  }

  checkLogin(url: string): boolean {
    if (!this.signinService.isSignedIn()) {
      this.router.navigate(['/signin'], {});
      return false;
    }

    return this.checkRoutePermission(url);
  }

  checkRoutePermission(url: string): boolean {
    if (!this.signinService.isSignedIn()) {
      this.router.navigate(['/signin'], {});
      return false;
    }

    const menuKey = this.toMenuKey(url);
    if (!menuKey || menuKey === 'main') {
      return true;
    }

    if (this.signinService.isMasterAdmin()) {
      return true;
    }

    const userInfo = this.signinService.getUserInfo();
    if (this.signinService.isSlaveAdmin() && (userInfo?.menuPermissions ?? []).includes(menuKey)) {
      return true;
    }

    this.router.navigate(['/main'], {});
    return false;
  }

  private toMenuKey(url: string): string | undefined {
    const segments = url.split('?')[0].split('#')[0].replace(/^\//, '').split('/');
    const path = segments[0];
    switch (path) {
      case '':
      case 'main':
        return 'main';
      case 'user':
        return 'user';
      case 'access':
        if (segments[1] === 'history') {
          return 'access-history';
        }
        if (segments[1] === 'permission') {
          return 'access-permission';
        }
        return undefined;
      case 'accesshistory':
        return 'access-history';
      case 'visit':
        return 'visit';
      case 'access-permission':
        return 'access-permission';
      case 'device':
        return 'device';
      case 'admin':
      case 'key-management':
      case 'system-log':
        return 'admin';
      default:
        return undefined;
    }
  }
}


/*
Copyright Google LLC. All Rights Reserved.
Use of this source code is governed by an MIT-style license that
can be found in the LICENSE file at https://angular.io/license
*/
